var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Security camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0756 14.9681L16.0609 14.3951C15.887 14.3 15.7918 14.1487 15.7751 13.9414C15.7585 13.7342 15.8351 13.5643 16.0051 13.4316L18.4386 11.6039C18.6253 11.4585 18.8284 11.3798 19.0479 11.3676C19.2675 11.3553 19.481 11.407 19.6881 11.5229L20.7029 12.0959C20.8767 12.191 20.9688 12.3423 20.9791 12.5496C20.9895 12.7568 20.916 12.9267 20.7589 13.0594L18.3251 14.8871C18.1385 15.0325 17.9354 15.1113 17.7159 15.1236C17.4964 15.1358 17.283 15.084 17.0756 14.9681ZM4.92838 20.2034C4.60921 20.2034 4.34079 20.0936 4.12313 19.8741C3.90563 19.6545 3.79688 19.385 3.79688 19.0659C3.79688 18.7467 3.90662 18.4783 4.12612 18.2606C4.34579 18.0431 4.61521 17.9344 4.93438 17.9344H8.80288V12.0621L5.98213 10.4149C5.43513 10.0877 5.08479 9.62271 4.93113 9.01988C4.77746 8.41721 4.86621 7.8423 5.19738 7.29513L6.61363 4.89263C6.94079 4.34946 7.40379 4.00205 8.00263 3.85038C8.60129 3.69871 9.17221 3.78646 9.71537 4.11363L17.8029 8.85063C18.1554 9.05796 18.341 9.36371 18.3596 9.76788C18.3783 10.172 18.228 10.4964 17.9089 10.7409L14.0649 13.6399C13.7075 13.897 13.3163 14.0391 12.8911 14.0661C12.466 14.0931 12.0625 13.9947 11.6806 13.7709L11.0719 13.4284V17.9284C11.0719 18.558 10.8501 19.0946 10.4066 19.5381C9.96313 19.9816 9.42654 20.2034 8.79688 20.2034H4.92838Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCamera);
export default __webpack_public_path__ + "static/media/security-camera.35967a940c3ebba8a2e5da1e4331868d.svg";
export { ForwardRef as ReactComponent };